import { render, staticRenderFns } from "./XYButtonV2.vue?vue&type=template&id=299cb57d&scoped=true"
import script from "./XYButtonV2.vue?vue&type=script&lang=js"
export * from "./XYButtonV2.vue?vue&type=script&lang=js"
import style0 from "./XYButtonV2.vue?vue&type=style&index=0&id=299cb57d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299cb57d",
  null
  
)

export default component.exports